import { derived, writable } from "svelte/store";

export interface Shortcut {
  id: string;
  name: string;
  shortcut: string;
  keywords: string;
  section: string;
  perform: () => void;
}

const initialState: Shortcut[] = [];

const shortcutsStore = () => {
  const { subscribe, update } = writable<Shortcut[]>(initialState);
  return {
    subscribe,
    addShortcuts: (shortcuts: Shortcut[]) => {
      update((state) => {
        const allShortcuts = [...state];
        shortcuts.forEach((shortcut) => {
          if (!state.some((s) => s.id === shortcut.id)) {
            allShortcuts.push(shortcut);
          }
        });
        return allShortcuts;
      });
      // removes the shortcuts passed as arguments from the state
      return () =>
        update((state) => {
          const updatedShortcuts = state.filter(
            (shortcut) => !shortcuts.some((s) => s.id === shortcut.id)
          );
          return updatedShortcuts;
        });
    },
  };
};

export const shortcuts = shortcutsStore();
export const shortcutsList = derived(shortcuts, ($shortcuts) => $shortcuts);
